import { parse } from 'browserslist';
import './_fitment-collection.scss';

const FITMENT_GRID = document.querySelector('#fitment-grid');

class CollectionAttributeSidebar {
    constructor(collectionTags) {
        this._collectionTagsGlobal = collectionTags; // Tags for the current collection, defined in the collection-attribute-sidebar.liquid snippet
        this._collectionTags = [];
        this._filterCollectionTags = []; // Tags for the current collection, if filters are applied
        this._filterData = {};
        this._priceData = [];
        this._appliedFilters = [];
        this._productsToRemove = [];
        this._newProducts = [];
        this._currentSortBy = {
            optionValue: 'default',
            dataSort: 'default',
        };
        this._currentPaginationState = {
            paginationIsVisible: true,
            paginationWrapper: null,
            resultsPerPage: parseInt(document.getElementById('fitment-grid').dataset.paginateBy)
        };
        this._hasFitment = false;
        this._currentFitment = null;
        this._isTier2Selected = false;
        this._tagsContainer = document.getElementById('tags');
        this.initData(this._collectionTagsGlobal);
        this.bindEvents();
        this.loadFiltersFromSession();
        this._pageProductCount = 0;
    }

    // Getters and setters
    get classState() {
        return {
            collectionTags: this._collectionTags,
            filterData: this._filterData,
            priceData: this._priceData,
            appliedFilters: this._appliedFilters,
            currentSortBy: this._currentSortBy,
            hasFitment: this._hasFitment,
        };
    }

    getState() {
        return this.classState;
    }

    openSidebar() {
        document.getElementById('collection-attribute-drawer').style.width =
            '100%';
        document.getElementById('collection-attribute-sidebar').style.width = window.innerWidth >= 1024 ? '450px' : '350px';
        document.getElementById('collection-attribute-sidebar').style.borderRight =
            '1px solid #000';
    }

    closeSidebar() {
        document.getElementById('collection-attribute-sidebar').style.width = '0';
        document.getElementById('collection-attribute-sidebar').style.borderRight = 'none';
        document.getElementById('collection-attribute-drawer').style.width =
            '0px';
    }

    async initData(collectionTagsArg) {
        this._hasFitment = localStorage.getItem('fitment') ? true : false
        this._currentFitment = this._hasFitment
            ? JSON.parse(localStorage.getItem('fitment'))
            : null
        this._collectionTags = collectionTagsArg
        const tags = this._collectionTags
        const tagsContainer = this._tagsContainer

        // Create Category section first
        const categorySection = this.createCollapsibleSection('Category', true);
        const categorySectionContent =
            categorySection.querySelector('#category-content');
        tagsContainer.appendChild(categorySection);

        this.processTags(tags, categorySectionContent, tagsContainer);
    }

    updateProductCardsLink() {

        if (FITMENT_GRID) {
            const dropdowns = document.querySelectorAll('.fitment_select');
            let queryParams = {};

            dropdowns.forEach((dropdown) => {
                const selectedOption = dropdown.options[dropdown.selectedIndex].value;
                if (selectedOption) {
                    queryParams[dropdown.id] = selectedOption;
                }
            });

            const queryString = Object.keys(queryParams)
                .map(key => `${key}=${encodeURIComponent(queryParams[key])}`)
                .join('&');
                

            const productCards = FITMENT_GRID.querySelectorAll('.card--product');
            
            productCards.forEach((card) => {
                let cardLink = card.querySelector('.card__link');
                cardLink.href = cardLink + `?${queryString}`;
            });
        }
    }

    processTags(tags, categorySectionContent, tagsContainer) {
        let hasCategoryTags = false;

        // Process Tier2 tags for the Category section
        tags
            .filter((tag) => tag.toLowerCase().startsWith('tier2:'))
            .forEach((tag) => {
                hasCategoryTags = true;
                const [, filterValue] = tag.split(':');
                this.createFilterElements(
                    categorySectionContent,
                    'Tier2',
                    filterValue,
                    'tier2'
                );
            });

        tags
            .filter((tag) => tag.toLowerCase().startsWith('tier3:'))
            .forEach((tag) => {
                hasCategoryTags = true;
                const [, filterValue] = tag.split(':');
                this.createFilterElements(
                    categorySectionContent,
                    'Tier3',
                    filterValue,
                    'tier3'
                );
            });

        // Process other tags 
        tags.forEach((tag) => {
            if (
                tag.includes(':') &&
                !tag.toLowerCase().startsWith('tier2:') &&
                !tag.toLowerCase().startsWith('tier3:') &&
                !tag.toLowerCase().includes('price')
            ) {
                const [filterType, filterValue] = tag.split(':')
                const transformedFilterType = this.toTitleCase(filterType)

                if (!this._filterData[transformedFilterType]) {
                    this._filterData[transformedFilterType] = []
                }

                this._filterData[transformedFilterType].push(filterValue)
            } else if (tag.toLowerCase().includes('price')) {
                const [, filterValue] = tag.split(':')
                this._priceData.push(Number(filterValue))
            }
        })

        function sortArray(arr) {
            return arr.sort((a, b) => {
              let numA = parseFloat(a);
              let numB = parseFloat(b);
          
              // Check if both a and b are numeric (either number or numeric string)
              let isANumeric = !isNaN(numA);
              let isBNumeric = !isNaN(numB);
          
              if (isANumeric && isBNumeric) {
                // Both are numeric, so compare them as numbers
                return numA - numB;
              } else if (isANumeric) {
                // Only a is numeric, so it comes before b
                return -1;
              } else if (isBNumeric) {
                // Only b is numeric, so it comes before a
                return 1;
              } else {
                // Both are non-numeric strings, so compare them as strings
                return a.localeCompare(b);
              }
            });
        }

        // Create facet filter sections
        for (const [filterType, filterValues] of Object.entries(this._filterData)) {
            const filterSection = this.createCollapsibleSection(filterType)
            tagsContainer.appendChild(filterSection)

            const contentDiv = filterSection.querySelector('.filter-content')

            // Sort all values ascending
            const sortedFilterValues = sortArray(filterValues);
            sortedFilterValues.forEach((filterValue, index) => {
                this.createFilterElements(contentDiv, filterType, filterValue, index)
            })
        }

        // Sort category section
        const categoryContent = document.getElementById('category-content')
        const categoryContentChildren = Array.from(categoryContent.children);
        categoryContentChildren.sort((a, b) => {
            const aText = a.querySelector('label').innerText
            const bText = b.querySelector('label').innerText
            return aText.localeCompare(bText)
        })
        categoryContentChildren.forEach((child) => {
            categoryContent.appendChild(child)
        })

        let filterHeaders = this._tagsContainer.querySelectorAll('.filter-header');
        if (hasCategoryTags) {
            filterHeaders.forEach((filterHeader) => {
                if (filterHeader.textContent === 'Category') {
                    filterHeader.parentElement.style.display = 'block';
                }
            });
        } else {
            filterHeaders.forEach((filterHeader) => {
                if (filterHeader.textContent === 'Category') {
                    filterHeader.parentElement.style.display = 'none';
                }
            });
        }
    }

    createFilterElements(container, filterType, filterValue, index) {
        if (filterType === 'Tier2') {
            // Handle category-specific logic for tier2 filterType
            return this.createCategoryFilterElements(
                container,
                filterType,
                filterValue,
                index
            )
        }

        const filterValueDiv = document.createElement('div')

        const checkbox = document.createElement('input')
        checkbox.type = 'checkbox'
        checkbox.id = filterValue + index
        checkbox.name = filterType
        checkbox.value = filterValue
        checkbox.classList.add('filter-checkbox', 'collection-filters__item')

        // Adding data attributes for filterType and filterValue
        checkbox.setAttribute('data-filter-type', filterType)
        checkbox.setAttribute('data-filter-value', filterValue)

        const label = document.createElement('label')
        label.htmlFor = checkbox.id
        label.innerText = filterValue
        label.classList.add('filter-checkbox-label')

        filterValueDiv.appendChild(checkbox)
        filterValueDiv.appendChild(label)

        container.appendChild(filterValueDiv)
    }

    createCategoryFilterElements(container, filterType, filterValue, index) {
        // Custom logic for category filters (i.e., tier2 tags)
        const filterValueDiv = document.createElement('div')

        const checkbox = document.createElement('input')
        checkbox.type = 'checkbox'
        checkbox.id = filterValue + index
        checkbox.name = filterType
        checkbox.value = filterValue
        checkbox.classList.add('filter-checkbox', 'collection-filters__item')

        // Adding data attributes for the Category section
        checkbox.setAttribute('data-filter-type', filterType)
        checkbox.setAttribute('data-filter-value', filterValue)

        const label = document.createElement('label')
        label.htmlFor = checkbox.id
        label.innerText = filterValue
        label.classList.add('filter-checkbox-label')

        filterValueDiv.appendChild(checkbox)
        filterValueDiv.appendChild(label)

        container.appendChild(filterValueDiv);
    }

    createCollapsibleSection(filterType, isCategorySection = false) {
        const sectionDiv = document.createElement('div')
        sectionDiv.className = 'filter-section'

        const headerDiv = document.createElement('div')
        headerDiv.className = 'filter-header'
        headerDiv.innerText = isCategorySection
            ? this._tagsContainer.dataset.categoryText
            : this.toTitleCase(
                filterType.toLowerCase().includes('length')
                    ? filterType + ' (IN)'
                    : filterType
            );

        const contentDiv = document.createElement('div')
        contentDiv.className = 'filter-content'

        if (isCategorySection) {
            contentDiv.id = 'category-content'
        }

        sectionDiv.appendChild(headerDiv)
        sectionDiv.appendChild(contentDiv)

        headerDiv.addEventListener('click', () => {
            const contentDiv = sectionDiv.querySelector('.filter-content')
            contentDiv.classList.toggle('show')
            headerDiv.classList.toggle('active')
        })

        return sectionDiv
    }

    async resetAndRebuildFilters(collectionTagsArg) {
        // Step 1: Reset filters
        const tagsContainer = this._tagsContainer
        this._filterData = {} // Clear existing filter data
        tagsContainer.innerHTML = '' // Clear existing filters

        // Step 2: Rebuild filters
        await this.initData(collectionTagsArg);

        // Step 3: Bind facet events
        this.bindCheckboxEvents();
        this.setAppliedFacetFiltersChecked();
    }

    bindEvents() {
        document
            .getElementById('open-sidebar')
            .addEventListener('click', () => this.openSidebar());
        document
            .getElementById('close-sidebar')
            .addEventListener('click', () => this.closeSidebar());

        window.addEventListener('click', (event) => {
            const sidebar = document.getElementById('collection-attribute-sidebar');
            const openButton = document.getElementById('open-sidebar');

            if (!sidebar.contains(event.target) && event.target !== openButton) {
                this.closeSidebar();
            }
        });
        this.bindCheckboxEvents();

        document
            .getElementById('clear-all-filters')
            .addEventListener('click', () => this.clearAllFilters())

    }

    handleFilterChange(event) {
        const filterType = event.target.name
        const filterValue = event.target.value

        if (event.target.checked) {
            this.addFilter(filterType, filterValue)
        } else {
            this.removeFilter(filterType, filterValue)
        }

        if (this._appliedFilters.length > 0) {
            document.getElementById('clear-all-filters').style.display = 'block'
        } else {
            document.getElementById('clear-all-filters').style.display = 'none'
        }
        this.saveFiltersToSession()
        this.applyFilters()
        this.resetPagination();
    }

    addFilter(filterType, filterValue) {
        if (filterType.includes('Tier2')) this.handleTier2Selection()

        let currentFilterTag = ''
        const currentTagLowerCase =
            filterType.toLowerCase() + ':' + filterValue.toLowerCase()
        for (let i = 0; i < this._collectionTags.length; i++) {
            if (
                this.handleizeTag(this._collectionTags[i].toLowerCase()) ===
                this.handleizeTag(currentTagLowerCase)
            ) {
                currentFilterTag = this._collectionTags[i]
                break
            }
        }
        if (!this._appliedFilters.includes(currentFilterTag)) {
            this._appliedFilters.push(currentFilterTag)
        }
    }

    removeFilter(filterType, filterValue) {
        let currentFilterTag = ''
        const currentTagLowerCase =
            filterType.toLowerCase() + ':' + filterValue.toLowerCase()
        for (let i = 0; i < this._collectionTags.length; i++) {
            if (
                this.handleizeTag(this._collectionTags[i].toLowerCase()) ===
                this.handleizeTag(currentTagLowerCase)
            ) {
                currentFilterTag = this._collectionTags[i]
                break
            }
        }
        if (this._appliedFilters.includes(currentFilterTag)) {
            const index = this._appliedFilters.indexOf(currentFilterTag)
            this._appliedFilters.splice(index, 1)
        }
    }

    async handleTier2Selection() {
        this._isTier2Selected = true
    }

    clearAllFilters() {
        this._appliedFilters = []
        document.querySelectorAll('.filter-checkbox').forEach((checkbox) => {
            checkbox.checked = false
        })
        document.getElementById('clear-all-filters').style.display = 'none'
        this.saveFiltersToSession()
        this.applyFilters()
    }

    async applyFilters() {
        this.toggleLoading(true)
        const newProductGrid = await this.getFilteredProducts()
        this.renderProductList(newProductGrid)
        this.renderAppliedFilterTags()
        this.toggleLoading(false)
        this.updateProductCardsLink();
    }

    async processProductData(collectionHandle) {
        const hasFilters = this._appliedFilters.length > 0 || this._hasFitment
        const isDefaultSort = this._currentSortBy.optionValue === 'default'

        let concatenatedFilters = null
        if (hasFilters) {
            concatenatedFilters = this._appliedFilters
                .map((filter) => this.handleizeTag(filter))
                .join('+')
        }

        try {
            if (hasFilters && isDefaultSort) {
                const products = await this.fetchProductData(
                    collectionHandle,
                    concatenatedFilters,
                    null
                )

                return sortBy(products, this._currentSortBy)
            } else if (hasFilters && !isDefaultSort) {
                return this.fetchProductData(
                    collectionHandle,
                    concatenatedFilters,
                    this._currentSortBy.optionValue
                )
            } else if (!hasFilters) {
                return this.fetchUnfilteredSortedProductData(
                    collectionHandle,
                    this._currentSortBy.optionValue
                )
            } else {
                // Optional fallback case
                console.warn('Unhandled case in processProductData');
            }
        } catch (error) {
            console.error(error);
        }
    }

    async fetchProductData(collectionHandle, concatenatedFilters, sortKey) {
        let url = sortKey
            ? `/collections/${collectionHandle}/${concatenatedFilters}?sort_by=${this._currentSortBy.optionValue}`
            : `/collections/${collectionHandle}/${await this.addConcatenatedUrlFitmentFilters(
                this._hasFitment,
                concatenatedFilters
            )}?sort_by=${this._currentSortBy.optionValue}`;

        const params = new URLSearchParams(window.location.search);

        if (params && params.has('page')) {
            url += `&page=${params.get('page')}`;
        }   

        try {
            const response = await fetch(url)
            if (!response.ok) {
                console.error('Fetch failed', response.status)
                return
            }
            const data = await response.text();
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = data;

            const newPaginationWrapper = tempDiv.querySelector('.pagination-wrapper');
            await this.handlePagination(newPaginationWrapper);

            return Array.from(
                tempDiv.querySelector('#main-collection-product-grid').children
            )
        } catch (error) {
            console.error(error);
        }
    }

    async fetchUnfilteredSortedProductData(collectionHandle, sortKey) {
        let url = !this._hasFitment
            ? `/collections/${collectionHandle}?sort_by=${sortKey}`
            : `/collections/${collectionHandle}/${await this.addConcatenatedUrlFitmentFilters(
                this._hasFitment,
                null
            )}?sort_by=${sortKey}`;

        const params = new URLSearchParams(window.location.search);
        if (params && params.has('page')) {
            url += `&page=${params.get('page')}`;
        }   

        try {
            const response = await fetch(url)
            if (!response.ok) {
                console.error('Fetch failed', response.status)
                return
            }
            const data = await response.text()
            const tempDiv = document.createElement('div')
            tempDiv.innerHTML = data

            const newPaginationWrapper = tempDiv.querySelector('.pagination-wrapper')
            await this.handlePagination(newPaginationWrapper)

            return Array.from(
                tempDiv.querySelector('#main-collection-product-grid').children
            )
        } catch (error) {
            console.error(error)
        }
    }

    async addConcatenatedUrlFitmentFilters(hasFitment, concatenatedFilters) {
        const fitment = await JSON.parse(localStorage.getItem('fitment'))

        let handleized

        // Concatenate the values dynamically
        let modifiedUrl = ''

        if (hasFitment) {
            handleized = Object.keys(fitment).reduce((acc, key) => {
                if (key !== 'submodel') {
                    acc[key] = fitment[key] ? this.handleizeTag(fitment[key]) : null
                }
                return acc
            }, {})

            const fitmentValues = Object.values(handleized).filter(Boolean).join('+')

            modifiedUrl = concatenatedFilters
                ? `${concatenatedFilters}+${fitmentValues}`
                : fitmentValues
        } else {
            modifiedUrl = concatenatedFilters || ''
        }

        return hasFitment ? modifiedUrl : concatenatedFilters
    }

    async handlePagination(newPaginationWrapper) {
        // Assign the newPaginationWrapper to state
        this._currentPaginationState.paginationWrapper = newPaginationWrapper

        // Update visibility state based on whether newPaginationWrapper exists
        this._currentPaginationState.paginationIsVisible =
            Boolean(newPaginationWrapper)
    }

    async getFilteredProducts() {
        this.toggleLoading(true)
        try {
            const collectionHandle = window.location.pathname.split('/')[2]
            const sortedProducts = await this.processProductData(collectionHandle);

            const productUl = document
                .querySelector('#main-collection-product-grid')
                .cloneNode(false);

            
            sortedProducts.forEach((product) => {
                productUl.appendChild(product);
            });

            const newProductGrid = document.createElement('div');
            newProductGrid.appendChild(productUl);

            if (this._hasFitment) {
                await this.applyFitmentToProductData(newProductGrid);
            }


            this.toggleLoading(false);


            this.handleCollectionTagsUpdate();

            return newProductGrid;
        } catch (error) {
            console.error('Error getting filtered products: ', error);
        }
    }

    renderProductList(productHtml) {
        const productListElement = document.querySelectorAll('.collection')[1]

        // Replace with the new products
        productListElement.children[0].innerHTML = productHtml.children[0].innerHTML

        // Remove non-fitting products
        if (this._productsToRemove.length > 0) {
            this._productsToRemove.forEach((sku) => {
                this.removeNonFittingProduct(sku);
            });
            this._productsToRemove = [];
        }

        if (this._newProducts.length > 0) {
            this._newProducts.forEach((product) => {
                const productID = product.productID;
                const productCard = document.querySelector(`[data-product-id="${productID}"]`);

                if (productCard) {
                    const position = product.position;
                    const driveType = product.drive_type;
                    const liftHeight = product.lift_height;

                    if (position != '' || driveType != '' || liftHeight != '') {
                        const cardSpecsContainer = productCard.querySelector('.card__specs-container');
                    
                        if (cardSpecsContainer) {
                            cardSpecsContainer.innerHTML = '';
                        
                            if (position != '') {
                                const html = `
                                    <div class='card-specs__group card-specs__group--size'>
                                        <p class='spec__heading'>
                                            Position
                                        </p>
                                        <p class='spec__content'>
                                            ${position == 'X' ? 'All' : position}
                                        </p>
                                    </div>`;
                                cardSpecsContainer.insertAdjacentHTML('beforeend', html);
                            }
                        
                            if (driveType != '') {
                                const html = `
                                    <div class='card-specs__group card-specs__group--size'>
                                        <p class='spec__heading'>
                                            Drive Type
                                        </p>
                                        <p class='spec__content'>
                                            ${driveType == 'X' ? 'All' : driveType}
                                        </p>
                                    </div>`;
                                cardSpecsContainer.insertAdjacentHTML('beforeend', html);
                            }
                        
                            if (liftHeight != '') {
                                const html = `
                                    <div class='card-specs__group card-specs__group--size'>
                                        <p class='spec__heading'>
                                            Lift Height
                                        </p>
                                        <p class='spec__content'>
                                            ${liftHeight == 'X' ? 'All' : liftHeight}
                                        </p>
                                    </div>`;
                                cardSpecsContainer.insertAdjacentHTML('beforeend', html);
                            }
                        }
                        
                    }
                }
            });
            this._newProducts = [];
        }

        // Update pagination based on state
        let paginationWrapper = document.querySelector('.pagination-wrapper');

        if (paginationWrapper) {
            if (this._currentPaginationState.paginationIsVisible) {
                if (this._currentPaginationState.paginationWrapper) {
                    paginationWrapper.replaceWith(
                        this._currentPaginationState.paginationWrapper
                    )
                }
                paginationWrapper.style.display = 'block';
            } else {
                paginationWrapper.style.display = 'none';
            }
        }

        this._pageProductCount = productListElement.children[0].children.length;

        if (productListElement.children[0].children.length === 0) {
            document.querySelector('.fitment-collection__empty').style.display = 'flex';
        } else {
            document.querySelector('.fitment-collection__empty').style.display = 'none';
        }

        document.getElementById('filters-count').textContent = `[${this._appliedFilters.length}`;
    }

    renderAppliedFilterTags() {
        const tagsContainer = document.getElementById('applied-filter-tags')
        tagsContainer.innerHTML = '' // Clear existing tags

        // Iterate through the applied filters
        this._appliedFilters.forEach((filter) => {
            // Strip the filter type and colon from the filter string
            const filterValue = filter.split(':')[1];
            // Create a div element for each tag
            const tagElement = document.createElement('div');
            tagElement.className = 'applied-filter-tag';
            tagElement.textContent = filterValue;

            // Create a remove button for the tag
            const removeButton = document.createElement('button');
            removeButton.textContent = '✕';
            removeButton.className = 'remove-filter-button';

            // Attach the click event to the remove button
            removeButton.addEventListener('click', () => {
                const [filterType, filterValue] = filter.split(':');
                this.removeFilter(filterType, filterValue);

                // Find the corresponding checkbox
                const checkboxSelector = `.filter-checkbox[name='${filterType}'][value='${filterValue}']`;
                const correspondingCheckbox = document.querySelector(checkboxSelector);

                // Uncheck the checkbox
                if (correspondingCheckbox) {
                    correspondingCheckbox.checked = false;
                }
                this.saveFiltersToSession();
                this.applyFilters();
            });

            tagElement.appendChild(removeButton);
            tagsContainer.appendChild(tagElement);
        });

        // Show "Clear Filters" link if there are any applied filters
        const clearAllFiltersLink = document.getElementById('clear-all-filters');
        if (this._appliedFilters.length > 0) {
            clearAllFiltersLink.style.display = 'block';
        } else {
            clearAllFiltersLink.style.display = 'none';
        }
    }

    async handleCollectionTagsUpdate() {
        this.toggleFilterLoading(true)
        const newTags =
            !this._hasFitment && this._appliedFilters.length === 0
                ? await this.getAllCollectionTags()
                : await this.getAllFilteredTags()

        this.updateCollectionTags(newTags)
    }

    async getAllCollectionTags() {
        try {
            let tagsFlat = [];
            let hasNextPage = true;
            let lastCursor = null;

            const collectionHandle = window.location.pathname.split('/')[2];

            if (this._filterCollectionTags.length === 0) {
                while (hasNextPage) {
                    let afterCursor = lastCursor ? `, after: "${lastCursor}"` : '';

                    let collectionQuery = `
                        query {
                            collectionByHandle(handle: "${collectionHandle}") {
                                products(first: 250${afterCursor}) {
                                    pageInfo {
                                        hasNextPage
                                    }
                                    edges {
                                        cursor
                                        node {
                                            tags
                                        }
                                    }
                                }
                            }
                        }`;

                    const response = await makeGraphQLRequest(collectionQuery)

                    hasNextPage =
                        response.data.collectionByHandle.products.pageInfo.hasNextPage
                    const edges = response.data.collectionByHandle.products.edges

                    if (edges.length > 0) {
                        lastCursor = edges[edges.length - 1].cursor

                        const tags = edges.map((edge) => edge.node.tags)
                        tagsFlat = tagsFlat.concat(tags.flat())
                    }
                }
            } else {
                tagsFlat = this._filterCollectionTags

                // Reset the filterCollectionTags array
                this._filterCollectionTags = []
            }

            return tagsFlat
        } catch (error) {
            console.error('Error getting collection tags: ', error)
        }
    }

    async getAllFilteredTags() {
        let tags = []
        const currentFitment = this._hasFitment
            ? JSON.parse(localStorage.getItem('fitment'))
            : null;

        const query = `query {
            products(first: 250${this.buildTagFilterQuery()}) {
                pageInfo {
                    hasNextPage
                }
                edges {
                    cursor
                    node {
                        tags
                        variants(first:1) {
                            edges {
                                node {
                                    metafield(namespace:"specs", key:"fitment_details") {
                                        value
                                        type
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }`

        const response = await makeGraphQLRequest(query);
        this._totalProductCount = response.data.products.edges.length;

        if (this._totalProductCount === 0 || this._totalProductCount <= this._currentPaginationState.resultsPerPage || this._currentPaginationState.paginationWrapper == null) {
            document.querySelector('.pagination-wrapper').style.display = 'none';
        } else {
            document.querySelector('.pagination-wrapper').style.display = 'block';
        }

        if (this._totalProductCount === 0 && this._collectionTags.length !== this._collectionTagsGlobal.length) {
            document.getElementById('open-sidebar').style.visibility = 'hidden';
        } else {
            document.getElementById('open-sidebar').style.visibility = 'visible';
        }

        if (currentFitment && response.data.products.edges.length > 0) {
            for (let i = 0; i < response.data.products.edges.length; i++) {
                const product = response.data.products.edges[i].node;
                if (product.variants && product.variants.edges.length > 0) {
                    const productMetafield =
                        product.variants &&
                            product.variants.edges.length > 0 &&
                            product.variants.edges[0].node.metafield
                            ? product.variants.edges[0].node.metafield.value
                            : null

                    const productMatched = productMetafield
                        ? isSubmodelMatch(productMetafield, currentFitment)
                        : true;

                    if (productMatched) {
                        tags.push(product.tags);
                    }
                }
            }

            return tags.flat()
        }

        const edges = response.data.products.edges;
        tags = edges.map((edge) => edge.node.tags)

        return tags.flat()
    }

    buildTagFilterQuery() {
        const collectionMap = {
            'shocks-coil-overs': 'Shocks & Coil-Overs',
            'coil-overs': 'Coil-Overs',
            'tools-accessories': 'Tools & Accessories',
        };
        const appliedFilters = this._appliedFilters;
        let newQueryParam = '';
        let hasReturnedCollectionHandle = false;

        if (!this._hasFitment && appliedFilters.length > 0) {
            newQueryParam = getFilterQuery(appliedFilters);
        } else if (this._hasFitment && appliedFilters.length === 0) {
            newQueryParam = `${manageTier2(
                appliedFilters
            )} AND ${applyFitmentToTagQuery()}`;
        } else if (this._hasFitment && appliedFilters.length > 0) {
            newQueryParam = getFilterQuery(appliedFilters);

            // Add fitment query to the tag query
            newQueryParam += ` AND ${applyFitmentToTagQuery()}`;
        }

        function getFilterQuery(filters) {
            return filters
                .map((filter) => {
                    const tier2Filter = manageTier2(filters, filter)
                    return tier2Filter
                        ? tier2Filter + ` AND tag:'${filter.replace(/"/g, '\\"')}'`
                        : `tag:'${filter.replace(/"/g, '\\"')}'`
                })
                .filter(Boolean)
                .join(' AND ')
        }

        function manageTier2(appliedFilters) {
            const collectionHandle = window.location.pathname.split('/')[2]
            const tier2Applied = appliedFilters.some((filter) =>
                filter.toLowerCase().includes('tier2')
            );

            if (tier2Applied || hasReturnedCollectionHandle) {
                return null
            }

            const result =
                collectionMap[collectionHandle] ||
                formatCollectionHandle(collectionHandle);

            if (result) {
                hasReturnedCollectionHandle = true;
            }

            return `tag:'${result}'`;
        }

        function applyFitmentToTagQuery() {
            const fitment = JSON.parse(localStorage.getItem('fitment'))

            const fitmentQueryParams = Object.entries(fitment)
                .map(([key, value]) => (value ? `tag:'${value}'` : null))
                .filter(Boolean);

            const fitmentQuery = fitmentQueryParams.join(' AND ').replace(/"/g, '\\"');

            return fitmentQuery;
        }

        function formatCollectionHandle(handle) {
            return handle
                .split('-')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')
        }

        return newQueryParam ? `, query: "${newQueryParam}"` : '';
    }

    async updateCollectionTags(newTags) {
        try {
            let tags = [];
            newTags.forEach((tag) => {
                if (!tags.includes(tag)) {
                    tags.push(tag);
                }
            });
            // Update the collection tags
            this._collectionTags = tags;
            await this.resetAndRebuildFilters(this._collectionTags);
            this.toggleFilterLoading(false);
        } catch (error) {
            console.error('Error updating collection tags: ', error);
        }
    }

    async applyFitmentToProductData(productDataHtml) {
        const elements = productDataHtml.querySelectorAll(
            '#main-collection-product-grid li > div'
        );
        let variantSkuList = [];

        elements.forEach((element) => {
            const variantObj = parseVariantData(element);
            variantSkuList.push(variantObj);
        });

        for (let i = 0; i < variantSkuList.length; i++) {
            const product = variantSkuList[i];
            const query = generateProductQuery(product.variantSku);
            const response = await makeGraphQLRequest(query);

            const productMetafield =
                response.data.products.edges.length > 0 &&
                    response.data.products.edges[0].node.variants.edges[0].node.metafield
                    ? response.data.products.edges[0].node.variants.edges[0].node
                        .metafield.value
                    : null;

            // Remove the product non-matching submodel
            const productsNotMatching = this.handleProductMetafieldAndTags(
                product,
                productMetafield,
                response
            );
        }
    }

    handleProductMetafieldAndTags(product, productMetafield, response) {
        let productsNotMatching = 0;
        const currentFitment = JSON.parse(localStorage.getItem('fitment'));

        if (currentFitment) {
            const productMatched = productMetafield
                ? isSubmodelMatch(productMetafield, currentFitment)
                : null

            if (productMatched === false && productMatched !== null) {
                productsNotMatching++
                this._productsToRemove.push(product.variantSku);
            } else {
                // Merge product and productMatched into one object
                const mergedProduct = {
                    ...product,
                    ...productMatched
                };

                this._newProducts.push(mergedProduct);
            }

            if (this._appliedFilters.length > 0) {
                const resTags = response.data.products.edges.map((edge) => edge.node.tags);
                const resTagsFlat = resTags.flat();

                resTagsFlat.forEach((tag) => {
                    if (!this._filterCollectionTags.includes(tag)) {
                        this._filterCollectionTags.push(tag);
                    }
                });

                document.getElementById('applied-filters-heading').style.visibility = 'visible';
            } else {
                document.getElementById('applied-filters-heading').style.visibility = 'hidden';
            }

            return productsNotMatching
        }
    }

    removeNonFittingProduct(sku) {
        const elements = document.querySelectorAll(
            '#main-collection-product-grid li > div'
        );

        elements.forEach((element) => {
            const variantObjSku = parseVariantData(element).variantSku
            if (variantObjSku === sku) {
                element.parentElement.remove();
            }
        });

        return;
    }

    toggleLoading(show) {
        const loadingOverlay = document.querySelector('.loading-overlay--custom');
        if (show) {
            loadingOverlay.style.display = 'block';
        } else {
            loadingOverlay.style.display = 'none';
        }
    }

    toggleFilterLoading(show) {
        const loadingDiv = `<div id="js-loading-div" class="loading-overlay loading-overlay--custom" style="display: block;">
                        <div class="loading-overlay__spinner" aria-label="{{ 'general.button_load_more.loading' | t }}"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>
                    </div>`;
        const tagsDiv = document.getElementById('tags');
        if (show) {
            tagsDiv.insertAdjacentHTML('afterbegin', loadingDiv);
        }
    }

    toTitleCase(str) {
        return str
            .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // Insert space before each capital letter
            .replace(/(\b[a-z](?!\s))/g, (x) => x.toUpperCase()) // Capitalize the first letter of each word
    }

    handleizeTag(input) {
        return input
            .toLowerCase() // Convert to lowercase
            .replace(/:/g, '-') // Replace colons with hyphens
            .replace(/\./g, '-') // Replace periods with hyphens
            .replace(/[^a-z0-9-\s]/g, '') // Remove characters that are not alphanumeric, spaces, or hyphens
            .replace(/\s+/g, '-') // Replace spaces with hyphens
            .replace(/-+/g, '-') // Replace multiple hyphens with a single hyphen
            .replace(/^-+|-+$/g, '') // Remove leading and trailing hyphens
    }

    setLoadingState() {
        this._sidebar.classList.add('loading');
    }

    saveFiltersToSession() {
        const state = {
            selectedPriceRange: this._selectedPriceRange,
            appliedFilters: this._appliedFilters,
            currentSortBy: this._currentSortBy.optionValue,
        };
        sessionStorage.setItem(
            `filters-${window.location.pathname.split('/')[2]}`,
            JSON.stringify(state)
        );
    }

    loadFiltersFromSession() {
        const savedState = sessionStorage.getItem(
            `filters-${window.location.pathname.split('/')[2]}`
        )

        if (savedState) {
            const state = JSON.parse(savedState)
            this._selectedPriceRange = state.selectedPriceRange || { min: 0, max: 0 }
            this._appliedFilters = state.appliedFilters || []
            this._currentSortBy.optionValue =
                state.currentSortBy.optionValue || 'default'

            // Restore checkboxes based on the applied filters
            this.setAppliedFacetFiltersChecked()

            this.applyFilters()

            // Show/Hide clear all filters button based on the applied filters
            if (this._appliedFilters.length > 0) {
                document.getElementById('clear-all-filters').style.display = 'block'
            } else {
                document.getElementById('clear-all-filters').style.display = 'none'
            }
        } else if (!savedState) {
            this.saveFiltersToSession()
            this.applyFilters()
        }
    }

    setAppliedFacetFiltersChecked() {
        this._appliedFilters.forEach((filterTag) => {
            const [filterType, filterValue] = filterTag.split(':')
            const checkboxSelector = `.filter-checkbox[name='${this.toTitleCase(
                filterType
            )}'][value='${filterValue}']`
            const checkboxElement = document.querySelector(checkboxSelector)
            if (checkboxElement) {
                checkboxElement.checked = true
            }
        })
    }

    bindCheckboxEvents() {
        document.querySelectorAll('.filter-checkbox').forEach((checkbox) => {
            checkbox.addEventListener('change', (event) =>
                this.handleFilterChange(event)
            );
        });
    }

    resetPagination() {
        // Get the current URL
        const url = new URL(window.location.href);

        // Remove the 'page' parameter
        url.searchParams.delete('page');

        // Update the URL without reloading the page
        window.history.replaceState({}, document.title, url.toString());
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const fitmentGrid = document.getElementById('fitment-grid');
    const lastFitmentConfig = localStorage.getItem('current_fitment');

    if (fitmentGrid) {
        /*
            clear fitment from localStorage if it exists and navigating from one vehicle type to another 
        */
        const currentFitmentType = fitmentGrid.dataset.vehicleType;

        if (lastFitmentConfig != currentFitmentType) {
            localStorage.removeItem('fitment');
            localStorage.removeItem('current_fitment');
        }

        const collectionAttributeSidebar = new CollectionAttributeSidebar(
            collectionTags
        );
    }
});

// Helper functions
function sortBy(products, currentSortBy) {
    switch (currentSortBy.optionValue) {
        case 'low-to-high':
            return products.sort((a, b) => {
                const priceA = parseFloat(
                    a
                        .querySelector('.price-item--regular')
                        .textContent.replace(/[^0-9.]/g, '')
                )
                const priceB = parseFloat(
                    b
                        .querySelector('.price-item--regular')
                        .textContent.replace(/[^0-9.]/g, '')
                )
                return priceA - priceB
            })
        case 'high-to-low':
            return products.sort((a, b) => {
                const priceA = parseFloat(
                    a
                        .querySelector('.price-item--regular')
                        .textContent.replace(/[^0-9.]/g, '')
                )
                const priceB = parseFloat(
                    b
                        .querySelector('.price-item--regular')
                        .textContent.replace(/[^0-9.]/g, '')
                )
                return priceB - priceA;
            })
        case 'alpha-asc':
            return products.sort((a, b) => {
                const titleA = a.querySelector('.card-title').textContent.trim()
                const titleB = b.querySelector('.card-title').textContent.trim()
                return titleA.localeCompare(titleB)
            })
        case 'alpha-desc':
            return products.sort((a, b) => {
                const titleA = a.querySelector('.card-title').textContent.trim()
                const titleB = b.querySelector('.card-title').textContent.trim()
                return titleB.localeCompare(titleA);
            })
        default:
            return products
    }
}

function parseVariantData(element) {
    const jsonData = element.getAttribute('data-json-product');
    
    /*
        The two lines below are commented-out because some properties within the JSON
        data were causing a malformed URI error when decodeURIComponent method called.
    */
    // const decodedStr = decodeURIComponent(jsonData);
    // const parsedObj = JSON.parse(decodedStr);
    const parsedObj = JSON.parse(jsonData);
    return {
        productTitle: parsedObj.variants[0].name,
        variantSku: parsedObj.variants[0].sku,
        productID: parsedObj.id,
    }
}

function generateProductQuery(variantSku) {
    return `query {
        products(first:1, query: "${variantSku}") {
            edges {
                node {
                    title
                    tags
                    variants(first:1) {
                        edges {
                            node {
                                metafield(namespace:"specs", key:"fitment_details") {
                                    value
                                    type
                                }
                            }
                        }
                    }
                }
            }
        }
    }`;
}

async function makeGraphQLRequest(query) {

    if (!window.storeFrontToken) {
        console.error('Storefront access token is missing');
        return null;
    }

    const response = await fetch(
        `https://${window.location.hostname}/api/graphql.json`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': window.storeFrontToken,
            },
            body: JSON.stringify({ query }),
        }
    );
    const json = await response.json();
    return json;
}

function isSubmodelMatch(fitmentStrings, fitmentSelection) {
    const { year, make, model, submodel, drive_type, fuel_type } =
        fitmentSelection;

    function stringToObject(fitmentStrings) {
        return fitmentStrings.split(';').map((str) => {
            const [year, make, model, sub_model, drive_type, fuel_type, body_num_doors, body_type, position, lift_height, quantity, base_vehicle_id, comments, fitment_map_details] =
                str.split('|');
            return { year, make, model, sub_model, drive_type, fuel_type, body_num_doors, body_type, position, lift_height, quantity, base_vehicle_id, comments, fitment_map_details }
        });
    }

    function isMatch(fitmentValue, inputValue, wildcard = 'x') {
        return inputValue && fitmentValue && (fitmentValue.toLowerCase() === inputValue.toLowerCase() || fitmentValue.toLowerCase() === wildcard);
    }

    const fitmentStringArray = stringToObject(fitmentStrings);
    let isSubModelMatch = false;

    for (const fitment of fitmentStringArray) {
        const yearMatch      = fitment.year === year;
        const makeMatch      = isMatch(fitment.make, make);
        const modelMatch     = isMatch(fitment.model, model);
        const driveTypeMatch = isMatch(fitment.drive_type, drive_type);
        const fuelTypeMatch  = isMatch(fitment.fuel_type, fuel_type);
        const submodelMatch  = isMatch(fitment.sub_model, submodel);

        // Check if all fields match (considering 'X' as wildcard for submodel)
        if (yearMatch && makeMatch && modelMatch && (driveTypeMatch || driveTypeMatch === undefined) && (fuelTypeMatch || fuelTypeMatch === undefined) && (submodelMatch || submodelMatch === undefined)) {
            isSubModelMatch = fitment;
            break;
        }
    }

    return isSubModelMatch;
};
